export default __webpack_public_path__ + "static/media/cpv_15_food-beverage.2e2c9ca2.svg";